import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MerchantAdmin.css';

function PaymentMethods() {
    const [methods, setMethods] = useState([]);
    const [newMethod, setNewMethod] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchMethods();
    }, []);

    const fetchMethods = async () => {
        const tg = window.Telegram.WebApp;
        try {
            const res = await axios.get('/api/merchant/payment-methods', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setMethods(res.data.methods || []);
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    };

    const addMethod = () => {
        if (newMethod.trim() === '') return;
        if (methods.includes(newMethod.trim())) {
            setMessage('该支付方式已存在');
            return;
        }
        setMethods([...methods, newMethod.trim()]);
        setNewMethod('');
        setMessage('');
    };

    const removeMethod = (index) => {
        const newMethods = [...methods];
        newMethods.splice(index, 1);
        setMethods(newMethods);
    };

    const saveMethods = async () => {
        setSaving(true);
        const tg = window.Telegram.WebApp;
        try {
            await axios.post('/api/merchant/payment-methods', { methods }, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setMessage('保存成功');
            setTimeout(() => setMessage(''), 2000);
        } catch (err) {
            setMessage('保存失败');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="loading">加载中...</div>;

    return (
        <div className="merchant-admin-card">
            <h2>支付方式设置</h2>
            <div className="merchant-admin-form">
                <div className="merchant-admin-form-group">
                    <label>已启用的支付方式</label>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        {methods.map((m, idx) => (
                            <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                <span>{m}</span>
                                <button
                                    className="merchant-admin-btn merchant-admin-btn-small merchant-admin-btn-secondary"
                                    onClick={() => removeMethod(idx)}
                                >
                                    删除
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="merchant-admin-form-group">
                    <label>添加新支付方式</label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <input
                            type="text"
                            value={newMethod}
                            onChange={e => setNewMethod(e.target.value)}
                            placeholder="例如：微信支付"
                        />
                        <button className="merchant-admin-btn" onClick={addMethod}>添加</button>
                    </div>
                </div>
                <button className="merchant-admin-btn" onClick={saveMethods} disabled={saving}>
                    {saving ? '保存中...' : '保存设置'}
                </button>
                {message && <p className="form-message">{message}</p>}
            </div>
        </div>
    );
}

export default PaymentMethods;